import { connect } from "react-redux";
import { useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import DeleteDialog from "../../helpers/DeleteDialog";
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Link } from "@mui/material";
import SelectRecipient from '../../helpers/SelectRecipient';
import StatusLayout from "components/Status";


function ProgramReport({ location, SetSelectedMenu, FetchDetails, programId, resourceId, resources, program, linemanager }) {
    const [open, setOpen] = useState(0);
    const [value, setValue] = useState({});
    const [list, setList] = useState([]);
    const [id, setId] = useState();
    const [reportedBy, setReportedBy] = useState([]);
    const [count, setCount] = useState(0);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [processedData, setProcessedData] = React.useState([]);
    const [challengeModalOpen, setChallengeModalOpen] = React.useState(false);
    const [currentChallenge, setCurrentChallenge] = React.useState("");
    const [statusModalOpen, setStatusModalOpen] = React.useState(false);
    const [currentStatus, setCurrentStatus] = React.useState("");

    const [period, setPeriodState] = React.useState({
        startDate: moment().startOf("W"),
        endDate: moment().endOf("W"),
    });
    const [recipients, setRecipients] = React.useState([]);
    const [isSelectRecipientOpen, setIsSelectRecipientOpen] = React.useState(false);
    const [division, setDivision] = useState(null)


    const updatePeriod = (newPeriod) => {
        setPeriodState(newPeriod);
    };

    const handleSubmitSuccess = () => {
        setCount((v) => v + 1);
    };

    useEffect(() => {
        // console.log("linemanager", linemanager);
    }, [linemanager]);

    const handleViewChallenge = (challenge) => {
        setCurrentChallenge(challenge);
        setChallengeModalOpen(true);
    };

    const handleCloseChallengeModal = () => {
        setChallengeModalOpen(false);
        setCurrentChallenge("");
    };


    const handleViewStatus = (status) => {
        setCurrentStatus(status);
        setStatusModalOpen(true);
    };

    const handleCloseStatusModal = () => {
        setStatusModalOpen(false);
        setCurrentStatus("");
    };
    useEffect(() => {
        SetSelectedMenu({
            menu: "program",
            title: "Program Management",
        });
        fetchResources();
    }, [SetSelectedMenu]);

    // const handleSelectRecipients = (selectedEmployees) => {
    //     setRecipients(selectedEmployees); 
    //     setValue0("recipients", selectedEmployees.map(e => e.id));
    //     setIsSelectRecipientOpen(false);
    // };

    useEffect(() => {
        if (open && linemanager) {
            setRecipients((prev) => {
                if (prev.length > 0 && prev[0]?.id === linemanager.id) return prev;
                return [linemanager, ...prev.filter(r => r.id !== linemanager.id)];
            });
        }
    }, [open, linemanager]);

    const handleSelectRecipients = (selectedEmployees) => {
        let updatedRecipients = selectedEmployees;
        if (linemanager) {
            updatedRecipients = [
                linemanager,
                ...selectedEmployees.filter(emp => emp.id !== linemanager.id)
            ];
        }
        setRecipients(updatedRecipients);
        setValue0("recipients", updatedRecipients);
        setIsSelectRecipientOpen(false);
    };

    useEffect(() => {
        if (program) {
            FetchDetails(`/api/structure/fetch/${program.divisionId}`).then(response => {
                if (response.status) {
                    setDivision(response.data.data);
                }
            });
        }
    }, [program, program?.divisionId, FetchDetails]);


    const fetchResources = async () => {
        const response = await FetchDetails(`/api/resource/listAll`);
        if (response.status) {
            setReportedBy(response?.data.data);
        }
    };

    const getWeekRange = (selectedDate) => {
        const date = moment(selectedDate);
        const startOfWeek = date.clone().startOf('isoWeek');
        const endOfWeek = date.clone().endOf('isoWeek');
        return {
            startDate: startOfWeek.format("YYYY-MM-DD"),
            endDate: endOfWeek.format("YYYY-MM-DD"),
        };
    };

    const columns = [
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{value}</span>
                ),
            },
        },
        {
            name: "date",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span className="text-custom-blue text-xs ">{moment(value).format("YYYY-MM-DD")}</span>
                ),
            },
        },
        {
            name: "impact",
            label: "Impact",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <span style={{
                        color: value === "high" ? "#FFA710" : value === "medium" ? "orange" : "#E41010",
                        fontSize: "13.92px"
                    }} className={"text-custom-blue text-xs "}>{value}</span>
                ),
            },
        },
        {
            name: "divisionId",
            label: "Unit",

        },

        {
            name: "overallStatus",
            label: "Overall Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    let displayText = "";
                    if (value) {
                        const match = value.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
                        const bodyContent = match ? match[1].trim() : value;
                        const plainText = bodyContent.replace(/<[^>]+>/g, "");
                        displayText = plainText.length > 10 ? plainText.substring(0, 10) + "..." : plainText;
                    }
                    return (
                        <Link
                            href="#"
                            onClick={(e) =>
                                e.preventDefault() ||
                                handleViewStatus(value)}
                            sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                        >
                            {displayText}
                        </Link>
                    );
                },
            },
        },
        {
            name: "challenges",
            label: "Challenges",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => {
                    // const displayText = value
                    //     ? value.length > 10
                    //         ? value.substring(0, 10) + "..."
                    //         : value
                    //     : "";

                    let displayText = "";
                    if (value) {
                        const match = value.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
                        const bodyContent = match ? match[1].trim() : value;
                        const plainText = bodyContent.replace(/<[^>]+>/g, "");
                        displayText = plainText.length > 10 ? plainText.substring(0, 10) + "..." : plainText;
                    }
                    return (
                        <Link
                            href="#"
                            onClick={(e) =>
                                e.preventDefault() ||
                                handleViewChallenge(value)}
                            sx={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                        >
                            {displayText}
                        </Link>
                    );
                },
            },
        },

        {
            name: "Resource.names",
            label: "Reported By",
            // options: {
            //     filter: true,
            //     sort: true,
            //     customBodyRender: (value) => (
            //         <span className="text-custom-blue text-xs ">{reportedBy.find((x) => x.id === value)?.names}</span>
            //     ),
            // },
        },

        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <StatusLayout status={value ?? "not available"} />
                ),
            },
        },

        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => (
                    <div className="flex items-center">
                        <IconButton onClick={() => {
                            setId(v);
                            const initialRecipients = linemanager ? [linemanager] : [];
                            setRecipients(initialRecipients);

                            setValue({
                                name: list.find((x) => x.id === v).name,
                                code: list.find((x) => x.id === v).code,
                                startDate: moment(list.find((x) => x.id === v).startDate).format("YYYY-MM-DD"),
                                endDate: moment(list.find((x) => x.id === v).endDate).format("YYYY-MM-DD"),
                                budget: list.find((x) => x.id === v).budget,
                                expenses: list.find((x) => x.id === v).expenses,
                                impact: list.find((x) => x.id === v).impact,
                                performance: list.find((x) => x.id === v).performance,
                                fundedBy: list.find((x) => x.id === v).fundedBy,
                                divisionId: list.find((x) => x.id === v).divisionId,
                                challenges: list.find((x) => x.id === v).challenges,
                                overallStatus: list.find((x) => x.id === v).overallStatus,
                                status: list.find((x) => x.id === v).status,
                                date: moment(list.find((x) => x.id === v).date).format("YYYY-MM-DD"),
                                // recipients: list.find((x) => x.id === v).recipients || initialRecipients,
                                //   setValue0("recipients", initialRecipients);
                                recipients:  initialRecipients,

                            });
                            setOpen(2);
                        }}>
                            <img
                                src={require("../../assets/icons/pencil.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm "

                                }
                            />
                        </IconButton>

                        <IconButton onClick={() => { setId(v); setDeleteOpen(true) }}>
                            <img
                                src={require("../../assets/icons/trash.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm "
                                }
                            />
                        </IconButton>

                    </div >
                ),
            },
        },
    ];

    const setValue0 = (name, val) => {
        if (!name) return;

        setValue((v) => {
            v[name] = val;

            if (name === "date") {
                const { startDate, endDate } = getWeekRange(val);
                v["startDate"] = startDate;
                v["endDate"] = endDate;
            }

            return { ...v };
        });
    };

    const onSuccess = () => setCount((v) => v + 1);
    return (
        <div className="w-full mb-12 px-4">
            <Dialog
                open={challengeModalOpen}
                onClose={handleCloseChallengeModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Challenge Details</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: currentChallenge }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseChallengeModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={statusModalOpen}
                onClose={handleCloseStatusModal}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Status Details</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: currentStatus }} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseStatusModal} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <DeleteDialog
                open={deleteOpen}
                setOpen={() => setDeleteOpen(false)}
                onSuccess={onSuccess}
                url={`/api/program/report/delete/${id}`}
            />

            <FormDialog
                maxWidth={"md"}
                col={6}
                open={open > 0}
                onSuccess={onSuccess}
                setOpen={setOpen}
                url={open === 1 ? "/api/program/report/create" : `/api/program/report/update/${id}`}
                title={open === 1 ? "Create New program Report" : "Edit program report"}
                fields={
                    [
                        {
                            name: "programId",
                            label: "ID",
                            value: programId,
                            required: false,
                            type: "text",
                            hidden: true,
                            disabled: true,
                            setValue: (val) => setValue0("programId", val),
                        },

                        {
                            name: "name",
                            label: "Program name",
                            value: value["name"],
                            required: true,
                            disabled: true,

                            setValue: (val) => setValue0("name", val),
                        },
                        {
                            name: "code",
                            label: "Code",
                            type: "text",
                            value: value["code"],
                            disabled: true,
                            required: true,
                            setValue: (val) => setValue0("code", val),
                        },
                        {
                            name: "date",
                            label: "Date",
                            type: "date",
                            value: value["date"],
                            // value: info?.date,
                            required: true,
                            setValue: (val) => setValue0("date", val),
                        },
                        {
                            name: "startDate",
                            label: "Start Date",
                            type: "date",
                            value: value["startDate"],
                            hidden: true,
                            // disabled: true,
                        },
                        {
                            name: "endDate",
                            label: "End Date",
                            type: "date",
                            value: value["endDate"],
                            hidden: true,
                            // disabled: true,
                        },
                        {
                            name: "impact",
                            label: "Impact",
                            type: "select",
                            values: [
                                { label: "High", value: "high" },
                                { label: "Medium", value: "medium" },
                                { label: "Low", value: "low" },
                            ],
                            value: value["impact"],
                            disabled: true,
                            setValue: (val) => setValue0("impact", val)
                        },
                        {
                            name: "currency",
                            label: "currency",
                            value: "Rwf",
                            required: false,
                            type: "text",
                            hidden: true,
                            disabled: true,

                            setValue: (val) => setValue0("currency", val),
                        },
                        {
                            name: "status",
                            label: "Status",
                            value: value["status"],
                            required: true,
                            disabled: true,

                            options: {
                                filter: true,
                                sort: true,
                                customBodyRender: (value) => (
                                    <span className="text-custom-blue text-xs ">{value}</span>
                                ),
                            },
                        },
                        {
                            name: "divisionId",
                            label: "Unit",
                            value: division?.name || "",
                            required: false,
                            type: "text",
                            disabled: true,
                            setValue: (val) => setValue0("divisionId"),
                        },
                        {
                            name: "recipients",
                            label: "Recipients",
                            value: value["recipients"] || [],
                            required: true,
                            col: 12,
                            render: () => (
                                <div className="mb-3 row">
                                    <div className="col-md-10">
                                        <TextField
                                            // value={recipients.map(r => r.names).join(', ')}
                                            value={(value["recipients"] || []).map(r => r.names).join(', ')}

                                            fullWidth
                                            margin="none"
                                            onClick={() => setIsSelectRecipientOpen(true)}
                                            multiline
                                            InputProps={{ readOnly: true }}
                                        />
                                    </div>
                                </div>
                            ),
                            setValue: (val) => setValue0("recipients", val),
                        },

                        {
                            name: "overallStatus",
                            label: "Overall Status",
                            value: value["overallStatus"],
                            required: false,
                            type: "textarea",
                            col: 12,
                            setValue: (val) => setValue0("overallStatus", val),
                        },
                        {
                            name: "challenges",
                            label: "Challenges",
                            value: value["challenges"],
                            required: false,
                            type: "textarea",
                            col: 12,
                            setValue: (val) => setValue0("challenges", val),
                        },


                    ]}
            />

            <SelectRecipient
                open={isSelectRecipientOpen}
                onClose={() => setIsSelectRecipientOpen(false)}
                confirm={handleSelectRecipients}
                selectedEmployees={recipients}
                resources={resources}
                settings={{ backgroundColorPrimary: '#1976d2' }}
            />

            <DatatableComponent
                order={location?.state?.order}
                onAddNew={() => {
                    if (programId) {
                        if (program) {
                            const initialRecipients = linemanager ? [linemanager] : [];
                            setRecipients(initialRecipients);
                            setValue({
                                name: program.name,
                                code: program.code,
                                startDate: moment(period.startDate).format("YYYY-MM-DD"),
                                endDate: moment(period.endDate).format("YYYY-MM-DD"),
                                // endDate: moment(program.endDate).format("YYYY-MM-DD"),
                                budget: program.budget,
                                expenses: program.expenses,
                                impact: program.impact,
                                performance: program.performance,
                                divisionId: program.divisionId,
                                // department: departments.find((x) => x.divisions.some((division) => division.id === program.divisionId))?.id,
                                description: program.description,
                                status: program.status,
                                date: moment().format("YYYY-MM-DD"),
                                recipients: initialRecipients,

                            });
                            setId(programId);
                            setOpen(1);
                        }
                    }
                }}
                processData={(data) => {
                    setList(data.data);
                    setProcessedData(data.data);
                    return data;
                }}
                elevation={1}
                pdf={true}
                excel={false}
                columns={columns}
                viewColumns={false}
                searchfield={true}
                search={false}
                url={`/api/program/report/list?count=${count}&programId=${programId}&resourceId=${resourceId}&period=${JSON.stringify(period)}`}
                title={
                    <div className="flex gap-4 items-center">
                        <div className="flex items-center gap-2">
                            <label className="text-[#054163] font-medium">From</label>
                            <input
                                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                                type="date"
                                value={
                                    Date.parse(period?.startDate)
                                        ? moment(period?.startDate).format("YYYY-MM-DD")
                                        : ""
                                }
                                max={period.endDate}
                                onChange={(e) => {
                                    updatePeriod({
                                        ...period,
                                        startDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                                    });
                                }}
                            />
                        </div>

                        <div className="flex items-center gap-2">
                            <label className="text-[#054163] font-medium">To</label>
                            <input
                                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                                type="date"
                                value={
                                    Date.parse(period?.endDate)
                                        ? moment(period?.endDate).format("YYYY-MM-DD")
                                        : ""
                                }
                                min={moment(period?.startDate).format("YYYY-MM-DD")}
                                onChange={(e) => {
                                    updatePeriod({
                                        ...period,
                                        endDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                                    });
                                }}
                            />
                        </div>
                    </div>
                }
            />
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramReport);
